// File: components/renderer/enemy/staffDemons.ts

// Big Red Pilot Demon
export const drawPilotDemon = (ctx: CanvasRenderingContext2D) => {
    // Body (Larger than Saja)
    ctx.scale(1.2, 1.2);
    ctx.fillStyle = "#c0392b"; // Dark Red
    ctx.beginPath();
    ctx.ellipse(0, -90, 40, 90, 0, 0, Math.PI * 2);
    ctx.fill();

    // Pilot Shirt
    ctx.fillStyle = "#ecf0f1"; // White
    ctx.beginPath();
    ctx.moveTo(-20, -150);
    ctx.lineTo(20, -150);
    ctx.lineTo(15, -80);
    ctx.lineTo(-15, -80);
    ctx.fill();

    // Tie
    ctx.fillStyle = "#2c3e50"; // Dark Blue
    ctx.beginPath();
    ctx.moveTo(0, -150);
    ctx.lineTo(-5, -145);
    ctx.lineTo(5, -145);
    ctx.fill();
    ctx.beginPath();
    ctx.moveTo(-5, -145);
    ctx.lineTo(5, -145);
    ctx.lineTo(3, -110);
    ctx.lineTo(-3, -110);
    ctx.fill();
    
    // Epaulets
    ctx.fillStyle = "#f1c40f"; // Gold
    ctx.fillRect(-25, -150, 10, 5);
    ctx.fillRect(15, -150, 10, 5);
    ctx.fillRect(-25, -145, 10, 2);
    ctx.fillRect(15, -145, 10, 2);

    // Head
    ctx.fillStyle = "#c0392b";
    ctx.beginPath();
    ctx.ellipse(0, -160, 25, 20, 0, 0, Math.PI * 2);
    ctx.fill();
    
    // Horns
    ctx.fillStyle = "#34495e";
    ctx.beginPath(); ctx.moveTo(-10, -175); ctx.quadraticCurveTo(-25, -200, -20, -170); ctx.fill();
    ctx.beginPath(); ctx.moveTo(10, -175); ctx.quadraticCurveTo(25, -200, 20, -170); ctx.fill();

    // Face
    ctx.fillStyle = "#f1c40f"; // Yellow eyes
    ctx.beginPath(); ctx.arc(-10, -165, 5, 0, Math.PI*2); ctx.fill();
    ctx.beginPath(); ctx.arc(10, -165, 5, 0, Math.PI*2); ctx.fill();
    ctx.fillStyle = "#000"; // Pupils
    ctx.fillRect(-11, -168, 2, 6);
    ctx.fillRect(9, -168, 2, 6);

    // Teeth
    ctx.fillStyle = "#fff";
    ctx.beginPath();
    ctx.moveTo(-15, -150);
    for (let i = 0; i < 6; i++) {
        const x = -15 + i * 5;
        const y = -150 + (i % 2 === 0 ? 0 : 3);
        ctx.lineTo(x, y);
    }
    ctx.lineTo(15, -150);
    ctx.fill();
};

// Female Staff Demon
export const drawFemaleStaffDemon = (ctx: CanvasRenderingContext2D) => {
    const SKIN_COLOR = "#d946ef"; // Fuchsia
    // Legs
    ctx.fillStyle = SKIN_COLOR;
    ctx.fillRect(-12, -70, 8, 70);
    ctx.fillRect(4, -70, 8, 70);
    
    // Skirt
    ctx.fillStyle = "#374151"; // Gray 700
    ctx.beginPath(); ctx.moveTo(-15, -70); ctx.lineTo(15, -70); ctx.lineTo(10, -100); ctx.lineTo(-10, -100); ctx.fill();

    // Torso (Vest)
    ctx.fillStyle = "#7f1d1d"; // Red 900
    ctx.fillRect(-12, -140, 24, 40);
    
    // Shirt
    ctx.fillStyle = "#fff";
    ctx.beginPath(); ctx.moveTo(-8, -140); ctx.lineTo(8, -140); ctx.lineTo(0, -130); ctx.fill();

    // Head
    ctx.fillStyle = SKIN_COLOR;
    ctx.beginPath(); ctx.ellipse(0, -150, 15, 18, 0, 0, Math.PI*2); ctx.fill();
    
    // Hair
    ctx.fillStyle = "#111";
    ctx.beginPath(); ctx.arc(0, -155, 16, Math.PI, 0); ctx.fill();
    ctx.fillRect(-5, -171, 10, 10); // Bun

    // Face
    ctx.fillStyle = "#16a34a"; // Green eyes
    ctx.beginPath(); ctx.arc(-6, -152, 3, 0, Math.PI*2); ctx.fill();
    ctx.beginPath(); ctx.arc(6, -152, 3, 0, Math.PI*2); ctx.fill();
    
    // Teeth
    ctx.fillStyle = "#fff";
    ctx.beginPath();
    ctx.moveTo(-8, -142);
    for (let i = 0; i < 5; i++) {
        const x = -8 + i * 4;
        const y = -142 + (i % 2 === 0 ? 0 : 2);
        ctx.lineTo(x, y);
    }
    ctx.lineTo(8, -142);
    ctx.fill();
};

// Male Staff Demon
export const drawMaleStaffDemon = (ctx: CanvasRenderingContext2D) => {
    const SKIN_COLOR = "#4f46e5"; // Indigo 600
    // Pants
    ctx.fillStyle = "#374151";
    ctx.fillRect(-12, -90, 10, 90); ctx.fillRect(2, -90, 10, 90);

    // Shirt
    ctx.fillStyle = "#fff";
    ctx.fillRect(-15, -150, 30, 60);

    // Tie
    ctx.fillStyle = "#4b5563";
    ctx.beginPath(); ctx.moveTo(0, -150); ctx.lineTo(-4, -145); ctx.lineTo(4, -145); ctx.fill();
    ctx.beginPath(); ctx.moveTo(-4, -145); ctx.lineTo(4, -145); ctx.lineTo(2, -110); ctx.lineTo(-2, -110); ctx.fill();
    
    // Head
    ctx.fillStyle = SKIN_COLOR;
    ctx.beginPath(); ctx.ellipse(0, -155, 16, 18, 0, 0, Math.PI*2); ctx.fill();

    // Hair
    ctx.fillStyle = "#7f1d1d";
    ctx.beginPath(); ctx.moveTo(-15, -165); ctx.quadraticCurveTo(0, -180, 15, -165); ctx.lineTo(15, -155); ctx.lineTo(-15, -155); ctx.fill();

    // Eyes - Three eyes (Deterministic fix for flickering bug)
    ctx.fillStyle = "#fff";
    ctx.beginPath(); ctx.arc(-7, -158, 3, 0, Math.PI*2); ctx.fill();
    ctx.beginPath(); ctx.arc(0, -158, 3, 0, Math.PI*2); ctx.fill();
    ctx.beginPath(); ctx.arc(7, -158, 3, 0, Math.PI*2); ctx.fill();
    ctx.fillStyle = "#b91c1c";
    ctx.beginPath(); ctx.arc(-7, -158, 1, 0, Math.PI*2); ctx.fill();
    ctx.beginPath(); ctx.arc(0, -158, 1, 0, Math.PI*2); ctx.fill();
    ctx.beginPath(); ctx.arc(7, -158, 1, 0, Math.PI*2); ctx.fill();

    // Teeth
    ctx.fillStyle = "#fff";
    ctx.beginPath();
    ctx.moveTo(-10, -145);
    for (let i = 0; i < 6; i++) {
        const x = -10 + i * 3.3;
        const y = -145 + (i % 2 === 0 ? 0 : 2);
        ctx.lineTo(x, y);
    }
    ctx.lineTo(10, -145);
    ctx.fill();
};

// Generic Water Demon (Standard)
export const drawWaterDemon = (ctx: CanvasRenderingContext2D) => {
    const SKIN_COLOR = "#22d3ee"; // Cyan-400
    
    // Legs (Bare/Watery)
    ctx.fillStyle = SKIN_COLOR;
    ctx.fillRect(-12, -70, 8, 70);
    ctx.fillRect(4, -70, 8, 70);

    // Swim Trunks
    ctx.fillStyle = "#1e3a8a"; // Blue-900
    ctx.fillRect(-15, -90, 30, 25);
    
    // Torso (Bare)
    ctx.fillStyle = SKIN_COLOR;
    ctx.fillRect(-16, -145, 32, 55);
    
    // Chest details (gills/abs?)
    ctx.fillStyle = "rgba(0,0,0,0.1)";
    ctx.beginPath(); ctx.moveTo(-16, -145); ctx.lineTo(0, -115); ctx.lineTo(16, -145); ctx.fill();

    // Head
    ctx.fillStyle = SKIN_COLOR;
    ctx.beginPath(); ctx.ellipse(0, -155, 18, 20, 0, 0, Math.PI*2); ctx.fill();

    // Horns (Wet/Sleek)
    ctx.fillStyle = "#164e63"; // Cyan-900
    ctx.beginPath(); ctx.moveTo(-10, -165); ctx.quadraticCurveTo(-25, -190, -20, -160); ctx.fill();
    ctx.beginPath(); ctx.moveTo(10, -165); ctx.quadraticCurveTo(25, -190, 20, -160); ctx.fill();

    // Eyes (Glowing Red)
    ctx.fillStyle = "#ef4444"; 
    ctx.shadowColor = "#ef4444"; ctx.shadowBlur = 5;
    ctx.beginPath(); ctx.arc(-7, -158, 4, 0, Math.PI*2); ctx.fill();
    ctx.beginPath(); ctx.arc(7, -158, 4, 0, Math.PI*2); ctx.fill();
    ctx.shadowBlur = 0;

    // Mouth (Sharp)
    ctx.fillStyle = "#fff";
    ctx.beginPath();
    ctx.moveTo(-10, -145);
    ctx.lineTo(0, -135);
    ctx.lineTo(10, -145);
    ctx.closePath();
    ctx.fill();
};

// Heavy Water Demon (Blobby/Tanky)
export const drawHeavyWaterDemon = (ctx: CanvasRenderingContext2D) => {
    const SKIN_COLOR = "#0e7490"; // Cyan-700 (Darker)
    
    // Legs (Thick)
    ctx.fillStyle = SKIN_COLOR;
    ctx.fillRect(-18, -60, 14, 60);
    ctx.fillRect(4, -60, 14, 60);

    // Swim Trunks (Wide)
    ctx.fillStyle = "#1e1b4b"; // Indigo-950
    ctx.fillRect(-22, -85, 44, 30);
    
    // Torso (Round/Fat)
    ctx.fillStyle = SKIN_COLOR;
    ctx.beginPath();
    ctx.ellipse(0, -120, 30, 40, 0, 0, Math.PI*2);
    ctx.fill();
    
    // Belly Details
    ctx.fillStyle = "rgba(0,0,0,0.2)";
    ctx.beginPath(); ctx.arc(0, -110, 20, 0, Math.PI); ctx.fill();

    // Head (Squashed)
    ctx.fillStyle = SKIN_COLOR;
    ctx.beginPath(); ctx.ellipse(0, -155, 22, 16, 0, 0, Math.PI*2); ctx.fill();

    // Fins on head instead of horns
    ctx.fillStyle = "#67e8f9"; // Cyan-300
    ctx.beginPath(); ctx.moveTo(-18, -155); ctx.lineTo(-30, -165); ctx.lineTo(-20, -145); ctx.fill();
    ctx.beginPath(); ctx.moveTo(18, -155); ctx.lineTo(30, -165); ctx.lineTo(20, -145); ctx.fill();

    // Eyes (One Cyclops Eye)
    ctx.fillStyle = "#facc15"; // Yellow
    ctx.shadowColor = "#facc15"; ctx.shadowBlur = 5;
    ctx.beginPath(); ctx.arc(0, -158, 8, 0, Math.PI*2); ctx.fill();
    ctx.fillStyle = "#000"; 
    ctx.beginPath(); ctx.arc(0, -158, 2, 0, Math.PI*2); ctx.fill();
    ctx.shadowBlur = 0;

    // Mouth (Wide Grin)
    ctx.fillStyle = "#fff";
    ctx.beginPath(); ctx.arc(0, -148, 10, 0, Math.PI); ctx.fill();
};

// Swift Water Demon (Lanky/Thin)
export const drawSwiftWaterDemon = (ctx: CanvasRenderingContext2D) => {
    const SKIN_COLOR = "#a5f3fc"; // Cyan-200 (Pale)
    
    // Legs (Thin/Long)
    ctx.fillStyle = SKIN_COLOR;
    ctx.fillRect(-8, -80, 6, 80);
    ctx.fillRect(2, -80, 6, 80);

    // Scale loincloth
    ctx.fillStyle = "#065f46"; // Emerald-800
    ctx.beginPath(); ctx.moveTo(-10, -80); ctx.lineTo(10, -80); ctx.lineTo(0, -60); ctx.fill();
    
    // Torso (Thin)
    ctx.fillStyle = SKIN_COLOR;
    ctx.fillRect(-10, -150, 20, 70);
    
    // Ribs
    ctx.strokeStyle = "rgba(0,0,0,0.1)";
    ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(-8, -130); ctx.lineTo(8, -130); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(-8, -120); ctx.lineTo(8, -120); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(-8, -110); ctx.lineTo(8, -110); ctx.stroke();

    // Head (Tall)
    ctx.fillStyle = SKIN_COLOR;
    ctx.beginPath(); ctx.ellipse(0, -160, 12, 22, 0, 0, Math.PI*2); ctx.fill();

    // Hair/Fin (Mohawk)
    ctx.fillStyle = "#0891b2"; // Cyan-600
    ctx.beginPath(); 
    ctx.moveTo(0, -182); 
    ctx.quadraticCurveTo(-10, -170, 0, -150);
    ctx.quadraticCurveTo(10, -170, 0, -182);
    ctx.fill();

    // Eyes (Multiple small dots)
    ctx.fillStyle = "#000"; 
    ctx.beginPath(); ctx.arc(-5, -165, 2, 0, Math.PI*2); ctx.fill();
    ctx.beginPath(); ctx.arc(5, -165, 2, 0, Math.PI*2); ctx.fill();
    ctx.beginPath(); ctx.arc(0, -160, 2, 0, Math.PI*2); ctx.fill();

    // Mouth (Small O)
    ctx.fillStyle = "#000";
    ctx.beginPath(); ctx.arc(0, -150, 3, 0, Math.PI*2); ctx.fill();
};